const NOTIFICATION_STATUSES = {
    INFO: 'info',
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error',
};
const NOTIFICATION_TIMEOUT = 15000;

export { NOTIFICATION_STATUSES, NOTIFICATION_TIMEOUT };
//# sourceMappingURL=Notifications.types.js.map
